import { render } from "./EnrollmentsView.vue?vue&type=template&id=bd64b234&scoped=true"
import script from "./EnrollmentsView.vue?vue&type=script&lang=js"
export * from "./EnrollmentsView.vue?vue&type=script&lang=js"

import "./EnrollmentsView.vue?vue&type=style&index=0&id=bd64b234&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd64b234"]])

export default __exports__